import React from 'react';

import Modal from '../../../../../../../components/Modal';

import StateChangeForm from './components/StateChangeForm';

const StateChangeModal = (props) => {
  const {
    bankAccountParams,
    onStateChange,
    onDialogClose,
    isDialogOpen,
    onSubmit,
    errors,
  } = props;

  return (
    <Modal
      title="Change Bank Account Duplication State"
      onClose={onDialogClose}
      onSave={onSubmit}
      isModalOpen={isDialogOpen}
    >
      <StateChangeForm
        bankAccountParams={bankAccountParams}
        onStateChange={onStateChange}
        errors={errors}
      />
      <div className="modal-actions">
        <button className="modal-save" type="submit" onClick={onSubmit}>
          Save Changes
        </button>
        <button className="modal-close" onClick={onDialogClose}>
          Cancel
        </button>
      </div>
    </Modal>
  );
};

export default StateChangeModal;
